/**
 * Small utility helpers for the time UI — never compute durations client-side.
 * These format server-supplied numbers only.
 */

export function formatMinutes(mins) {
  if (mins == null) return "—";
  const total = Math.max(0, Math.floor(mins));
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
}

export function formatDecimalHours(mins) {
  if (mins == null) return "—";
  return (mins / 60).toFixed(2);
}

export function formatTimeInTz(iso, tz) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: tz || "UTC",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatDateInTz(iso, tz) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: tz || "UTC",
      weekday: "short",
      month: "short",
      day: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatWeekLabel(startIso, endIso) {
  const opts = { month: "short", day: "numeric" };
  const start = new Date(startIso + "T00:00:00");
  const end = new Date(endIso + "T00:00:00");
  const year = end.getFullYear();
  return `Week of ${start.toLocaleDateString("en-US", opts)} – ${end.toLocaleDateString("en-US", opts)}, ${year}`;
}
